module.exports = __webpack_public_path__ + "img/e-referral-procedures.c577b42b.png";